module.exports = __webpack_public_path__ + "static/media/mask.ed37a87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/mask.png
// module id = 2251
// module chunks = 2